// vendor modules
import React from "react"
import PropTypes from "prop-types"
// internal modules
import omit from "lodash/omit"
import Select from "app/static/frontend/selects/components/Select"
// helper functions
import { setClearableFilter } from "shared/selects/helperFunctions"

// This is a wrappping class around our base Select component. It renders
// that component with some necessary configuration.
// loadOptions should be a function which returns a list of options
// the configuration for each of our EnumSelects should take place in the
// containers folder for this subfeature module
export const EnumSelect = (props) => {
    const loadOptions = () => {
        // allowing for setting clearableValue to be false if we choose to
        const { disableRemoveOption, disableRemoveOptionKey } = props
        // need to add id from value

        return props.options
            .map((item) => ({
                [props.label]: item[props.label],
                value: item.value,
                label: item.label,
                icon: item.icon,
                id: item[props.valueKey] || item.id,
                ...(props.extraFields
                    ? props.extraFields.reduce((accumulator, extraField) => {
                          accumulator[extraField] = item[extraField]
                          return accumulator
                      }, {})
                    : {}),
                isDisabled: item.disabled,
            }))
            .map(setClearableFilter, { disableRemoveOption, disableRemoveOptionKey })
    }

    const filterOption = ({ label, value, data }, filter) => {
        if (data[props.label]) {
            return data[props.label].toLowerCase().includes(filter.toLowerCase())
        }

        return true
    }

    return (
        <Select
            {...omit(props, ["disableRemoveOption", "disableRemoveOptionKey"])}
            async={props.async}
            allowExpandUp={props.allowExpandUp}
            loadOptions={loadOptions}
            onChange={props.onChange}
            placeholder={props.placeholder}
            label={props.label}
            multi={props.multi}
            filterOption={props.filterOption || filterOption}
        />
    )
}

EnumSelect.propTypes = {
    allowExpandUp: PropTypes.bool,
    async: PropTypes.bool,
    extraFields: PropTypes.array,
    filterOption: PropTypes.func,
    label: PropTypes.string,
    multi: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    valueKey: PropTypes.string,
}

EnumSelect.defaultProps = {
    allowExpandUp: false,
    async: false, // keeping this as false to not break things
    multi: false,
    label: "label",
    valueKey: "value",
}

export default EnumSelect
